// platform/app/src/hooks/useClients.ts
import { useQuery } from '@tanstack/react-query'
import { supabase } from '@loop3/supabase-client'
import type { Client } from '@/lib/types'

export function useClients() {
  return useQuery({
    queryKey: ['clients'],
    queryFn: async (): Promise<Client[]> => {
      const { data, error } = await supabase
        .from('clients')
        .select(
          'id, prefix, internal_id, name, color, sort_order, since_month, notion_url, linear_team_url, github_org_url, account_owner_id, archived_at'
        )
        .is('archived_at', null)
        .order('sort_order', { ascending: true })
      if (error) throw error
      return (data ?? []) as Client[]
    },
    staleTime: 60_000,
  })
}
